
import React, { Component } from "react";
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// action
import { forgetUser, resetForgetPWState } from '../../store/actions';

// import images
import { IconButton, Stack } from "@mui/material";
// import logodark from "../../assets/images/Aspeed_Logo.png";
import { Icon } from "@iconify/react/dist/iconify.js";
import LoadingDialog from "../../components/Common/LoadingDialog";
import withRouter from "../../components/Common/withRouter";
import CustomButton from "../../components/Form/CustomButton";
import CustomTextField from "../../components/Form/CustomTextField";
import Helpers from "../../helpers/helpers";

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: false, email: '', emailSent: false, resetPassword: false, showPWRe: false, showPw: false, resetPwSent: false };

        // handleValidSubmit
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
        this.handleResend = this.handleResend.bind(this);
        this.props.resetForgetPWState();
    }

    // handleValidSubmit
    handleValidSubmit() {
        this.setState({ loading: true });
        const values = {
            email: this.state.email,
        }
        // this.props.forgetUser(values);
        this.setState({ loading: false, emailSent: true, resetPassword: false });
        // window.location.href = "/password-sent";
    }

    handleResend() {
        this.setState({ loading: false, emailSent: false, resetPassword: false, email: "" });
    }

    handleResetPassword() {
        this.setState({ loading: false, emailSent: false, resetPassword: true });
    }

    handleResetPw() {
        this.setState({ resetPwSent: true });
    }

    render() {
        return (
            <React.Fragment>
                <div>
                    <LoadingDialog open={this.props.loading} />
                    <Container fluid className="p-0">
                        <Row className="g-0">
                            <Col lg={12}>
                                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                    <div className="w-100">
                                        <Row className="justify-content-center">
                                            <Col xs={12} md={8} lg={6} xl={4}>
                                                <div>
                                                    <div className="text-center">
                                                        <div>
                                                            {/* <Link to="/" className="logo"><img src={logodark} height="100" alt="logo" /></Link> */}
                                                        </div>

                                                    </div>
                                                    {
                                                        this.state.resetPwSent ?
                                                            // Pwsuccess
                                                            <>
                                                                <div className="text-center mb-2" style={{ fontSize: 24, fontFamily: 'FunnelSans', fontWeight: 600 }}>Password changed!</div>
                                                                <p className="text-muted text-center pb-4" style={{ color: '#717680' }}>Your password has been changed successfully.</p>
                                                                <Stack className="mt-2" gap={2} direction={"column"}>
                                                                    <div className="mt-4 text-center">
                                                                        <CustomButton
                                                                            title={this.props.loading ? "Loading..." : "Back to Login"}
                                                                            disabled={this.props.loading}
                                                                            backgroundColor={'var(--bs-theme-color-2)'}
                                                                            textColor={'white'}
                                                                            width={'100%'}
                                                                            borderRadius={8}
                                                                            hoverColor="white"
                                                                            hoverBackgroundColor={"black"}
                                                                            press={() => Helpers?.routeToLogin()}
                                                                        />
                                                                    </div>
                                                                </Stack>
                                                            </>
                                                            :
                                                            <>
                                                                <div className="text-center mb-2 pb-2" style={{ fontSize: 24, fontFamily: 'FunnelSans', fontWeight: 600 }}>Reset your password</div>
                                                                <p className="text-center pb-4" style={{ color: '#717680' }}>Please enter a new password.</p>
                                                                <Stack className="mt-2" gap={2} direction={"column"}>
                                                                    <CustomTextField
                                                                        placeholder='Confirm new password'
                                                                        typePw={this.state.showPW ? 'text' : 'password'}
                                                                        title={"Confirm New Password"}
                                                                        error={this.props.message?.errors?.password}
                                                                        values={this.state.password}
                                                                        variant="standard"
                                                                        style={{ backgroundColor: 'white' }}
                                                                        onChange={(e) => this.setState({ password: e })}
                                                                        InputProps={{
                                                                            endAdornment: <IconButton
                                                                                aria-label="toggle password visibility"
                                                                                onClick={(e) => this.setState({ showPW: !this.state.showPW })}
                                                                                edge="end"
                                                                            >
                                                                                {this.state.showPW ? <Icon icon="ri:eye-line" width="24" height="24" /> : <Icon icon="ri:eye-close-line" width="24" height="24" />}
                                                                            </IconButton>,
                                                                            // startAdornment: <Icon icon="fluent:lock-closed-32-regular" className="me-2 text-muted" width="24" height="24"></Icon>,
                                                                        }}
                                                                    />
                                                                    {/* <CustomTextField
                                                                            placeholder='Re-enter new password'
                                                                            typePw={this.state.showPWRe ? 'text' : 'password'}
                                                                            title={"Confirm Password"}
                                                                            values={this.state.confirm_password}
                                                                            error={this.props.message?.errors?.confirm_password}
                                                                            variant="standard"
                                                                            style={{ backgroundColor: 'white' }}
                                                                            onChange={(e) => this.setState({ confirm_password: e })}
                                                                            InputProps={{
                                                                                endAdornment: <IconButton
                                                                                    aria-label="toggle password visibility"
                                                                                    onClick={(e) => this.setState({ showPWRe: !this.state.showPWRe })}
                                                                                    edge="end"
                                                                                >
                                                                                    {this.state.showPW ? <Icon icon="ri:eye-line" width="24" height="24" /> : <Icon icon="ri:eye-close-line" width="24" height="24" />}
                                                                                </IconButton>,
                                                                                startAdornment: <Icon icon="fluent:lock-closed-32-regular" className="me-2 text-muted" width="24" height="24"></Icon>,
                                                                            }}
                                                                        /> */}
                                                                    <div className="mt-4 text-center">
                                                                        <CustomButton
                                                                            title={this.props.loading ? "Loading..." : "Reset Password"}
                                                                            disabled={this.props.loading}
                                                                            backgroundColor={'var(--bs-theme-color-2)'}
                                                                            textColor={'white'}
                                                                            width={'100%'}
                                                                            borderRadius={8}
                                                                            hoverColor="white"
                                                                            hoverBackgroundColor={"black"}
                                                                            press={() => this.handleResetPw()}
                                                                        />
                                                                    </div>
                                                                    {/* <div className="mt-4 text-center">
                                                                            <Link to="/login" className="clickable-text" style={{ fontSize: 18, color: "#525252" }}> Back to Login</Link>
                                                                        </div> */}
                                                                </Stack>
                                                            </>
                                                    }
                                                </div>

                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                            {/* <Col lg={8}>
                                <div className="authentication-bg">
                                    <div className="bg-overlay"></div>
                                </div>
                            </Col> */}
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { message, forgetError, loading } = state.Forget;
    return { message, forgetError, loading };
}

export default withRouter(
    connect(mapStatetoProps, { forgetUser, resetForgetPWState })(ResetPassword)
);
